import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import BuildingCatalogue from '../components/BuildingCatalogue';
import Team from '../components/Team';
import SubletSection from '../components/SubletSection';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home: React.FC = () => (
  <>
    <Navbar />
    <Hero />
    <About />
    <BuildingCatalogue />
    <Team />
    <SubletSection />
    <Contact />
    <Footer />
  </>
);
export default Home;
